import React from "react";
import { Link } from "react-router-dom";

function renderButton(
  { text, className, size, disabled, to },
  color,
  icon,
  defaultText
) {
  return (
    <Link
      disabled={disabled}
      className={` ${disabled && "disabled"} btn btn-${color} ${className}${
        size ? ` btn-${size}` : ""
      }`}
      to={to}
    >
      <i className={icon} style={{ marginRight: "8px" }} />{" "}
      {text ? text : defaultText}
    </Link>
  );
}

const EditButtonLink = (props) => {
  return renderButton(props, "info", "fa fa-edit");
};

const RemoveButtonLink = (props) => {
  return renderButton(props, "danger", "fa fa-trash");
};

const NewButtonLink = (props) => {
  return renderButton(props, "primary", "fa fa-plus");
};

const UpdateButtonLink = (props) => {
  return renderButton(props, "primary", "fa fa-edit");
};

const SuccessButtonLink = (props) => {
  return renderButton(props, "success", "");
};

const SecondaryEditButtonLink = (props) => {
  return renderButton(props, "secondary", "fa fa-edit");
};

export {
  EditButtonLink,
  RemoveButtonLink,
  NewButtonLink,
  UpdateButtonLink,
  SuccessButtonLink,
  SecondaryEditButtonLink,
};
